// assets
import { ShopOutlined, BarcodeOutlined, MobileOutlined, DatabaseOutlined, FileSearchOutlined, HistoryOutlined } from '@ant-design/icons';

// icons
const icons = {
  ShopOutlined,
  BarcodeOutlined,
  MobileOutlined,
  DatabaseOutlined,
  FileSearchOutlined,
  HistoryOutlined
};

// ==============================|| MENU ITEMS - MAGAZZINO ||============================== //

const magazzino = {
  id: 'group-magazzino',
  title: 'Magazzino',
  type: 'group',
  children: [
    {
      id: 'magazzino',
      title: 'Listini Magazzino',
      type: 'item',
      url: '/magazzino',
      icon: icons.ShopOutlined,
      breadcrumbs: false,
      roles: ['admin', 'ufficio']
    },
    {
      id: 'giacenze',
      title: 'Giacenze',
      type: 'item',
      url: '/giacenze',
      icon: icons.BarcodeOutlined,
      breadcrumbs: false,
      roles: ['admin', 'ufficio']
    },
    {
      id: 'movimenti-giacenza',
      title: 'Movimenti giacenza',
      type: 'item',
      url: '/movimenti-giacenza',
      icon: icons.HistoryOutlined,
      breadcrumbs: false,
      roles: ['admin', 'ufficio']
    },
    {
      id: 'mobile-inventory',
      title: 'Scanner Inventario',
      type: 'item',
      url: '/mobile-inventory',
      icon: icons.MobileOutlined,
      breadcrumbs: false,
      roles: ['admin', 'ufficio']
    },
    {
      id: 'gestione-inventari',
      title: 'Gestione Inventari',
      type: 'item',
      url: '/inventari',
      icon: icons.DatabaseOutlined,
      breadcrumbs: false,
      roles: ['admin', 'ufficio']
    },
    {
      id: 'operazioni',
      title: 'Operazioni',
      type: 'item',
      url: '/operazioni',
      icon: icons.FileSearchOutlined,
      breadcrumbs: false,
      roles: ['admin', 'ufficio']
    },
    {
      id: 'operazioni-veca',
      title: 'Operazioni VECA',
      type: 'item',
      url: '/operazioni-veca',
      icon: icons.FileSearchOutlined,
      breadcrumbs: false,
      roles: ['admin', 'ufficio']
    }
  ]
};

export default magazzino;